import styles from './CyclePhase.module.css';

export const cyclePhaseClass = (phase: string | null) => (phase ? (styles[phase] ?? '') : '');

export const CyclePhaseDot = ({ phase, round }: { phase: string; round?: boolean }) => (
	<span
		className={`${styles.dot} ${round ? styles.round : ''} ${cyclePhaseClass(phase)}`}
		aria-hidden="true"
	/>
);
